// Script to handle insurance radio button keyboard focus
document.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Return') {
        const wrapper = e.target.closest('.insurance-choice-wrapper-list');
        if (!wrapper) {
            return;
        }
        const radio = wrapper.querySelector('input[type="radio"]');
        if (radio) {
            e.preventDefault();
            radio.click();
        }
    }
});
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    /* =========================
       1 LABEL BASED CUSTOM RADIOS
       ========================= */
    const label = e.target.closest('label.selection-option');
    if (label) {
        e.preventDefault();
        const radio = label.querySelector('input[type="radio"]');
        if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return; // stop here
    }
    /* =========================
       2️ li BASED RADIOS (DYNAMIC CLASSES)
       ========================= */
    const li = e.target.closest('li');
    if (
        li &&
        li.hasAttribute('tabindex') &&               // focusable
        li.querySelector('input[type="radio"]')      // contains radio
    ) {
        e.preventDefault();
        const radio = li.querySelector('input[type="radio"]');
        radio.checked = true;
        radio.click();
        radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
});